/**
 * 绑定手机号弹框
 */
import { FC, useState } from 'react'
import { Button, Form, Modal, Toast } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less'
import { PhoneFormItems } from '@/components/PhoneFormItems'
import { bindPhone } from '@/api/user'
import { AgreeFormItem } from '@/components/AgreeFormItem'
import { SMS_TYPE } from '@/components/SmsCodeFormItem/const'
import { actionTypes, useStoreState, useStoreDispatch } from '@/store'


export const BindPhoneModal: FC<{
  visible: boolean,
  setVisible(visible: boolean): any,
  addOrder(contactPhone?: string): any
}> = ({ visible, setVisible, addOrder }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false)
  const { centerConfig, inner, isPhoneStrate } = useStoreState()
  const dispatch = useStoreDispatch()

  // 点击操作按钮 绑定手机号
  const onFinish = async (values) => {
    setSubmitting(true)
    let extra = {}
    if (inner.isFrom && inner.type && !isPhoneStrate) {
      extra = { type: inner.type, code: '1234' }
    }

    const res = await bindPhone({ ...values, ...extra, phoneStrategy: centerConfig['phoneStrategy'] }).finally(() => setSubmitting(false)).catch(err => err)
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('order.modal.toast-suc')}` });
      setVisible(false);
      addOrder(values.phone);
      // 重置
      dispatch({ type: actionTypes.SET_PHONE_STRATE, payload: false })
    } else {
      Toast.show({ icon: 'fail', content: `${res.msg}` });
    }
  }

  const titleContent = (type: number) => {
    switch (type) {
      case 1:
        return `${t('order.modal.title-1')}`

      default:
        return `${t('order.modal.title-2')}`
    }
  }

  const textContent = (type: number) => {
    switch (type) {
      case 1:
        return `${t('order.modal.text-1')}`

      default:
        return `${t('order.modal.text-2')}`
    }
  }

  return (
    <Modal
      visible={visible}
      bodyClassName={css.BindPhoneModal}
      showCloseButton
      onClose={() => setVisible(false)}
      destroyOnClose
      content={
        <Form form={form} className={css.Form} onFinish={onFinish}>
          <h4 className={css.title}>{titleContent(centerConfig['phoneStrategy'])}</h4>
          <div className={css.text}>{textContent(centerConfig['phoneStrategy'])}</div>
          <div className={css.PageHd}>
            <PhoneFormItems form={form} model={{ type: SMS_TYPE.BIND_PHONE }} />
            {centerConfig['phoneStrategy'] === 1 && <AgreeFormItem name={'agree'} />}
          </div>

          <div className={css.BtnSubmitWrap}>
            <Button className={css.BtnSubmit} block type='submit' color='primary' loading={submitting}>{t('common.submit')}</Button>
          </div>
        </Form>
      }
    />
  )
}
